import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from "@angular/material";
import { HomeComponent } from "../home/home.component";
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { ProductsService } from '../../services/products.service';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: 'app-advatiseupdate',
  templateUrl: './advatiseupdate.component.html',
  styleUrls: ['./advatiseupdate.component.css']
})
export class AdvatiseupdateComponent implements OnInit {
  advcategories: any;
  advProduct: any;
  user : any;
  url;
  format;
  productImg: any = "";
  constructor(
    private dialogRef: MatDialogRef<HomeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private productService: ProductsService,
    private cd: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private http: HttpClient,
  ) { }

  ngOnInit() {
    this.advcategories = this.data.categoryList;
    this.advProduct = this.data.products;
    console.log(this.advProduct);
    this.url = "https://liveapi-vmart.softexer.com"+this.advProduct.advertiesmentImage;
    this.format = 'image';
    this.user = JSON.parse(localStorage.getItem("user")) || null;
    console.log(this.user);
    if (!this.user && !this.user.PhoneNumber) {
      this.openSnackBar("Please Login..!","");
      this.dialogRef.close(false);
    }    
  }
  UpdateAdvertise(){
    let phno = this.user.PhoneNumber.substr(3);
    let payLoad = {
      PhoneNumber : phno,
      type:"Advertiesments",
      Id : this.advProduct.advertiesmentID
    }
    console.log(payLoad);
    const productDetails = new FormData();
    productDetails.append("image",this.productImg);
    productDetails.append("dashboardInfo", JSON.stringify(payLoad));
    let token = localStorage.getItem('token');
    this.productService.adminUpdateAdvertiseImage(productDetails, token).subscribe((res) => {
      console.log("Res", res)
      if (res.response == 3) {
        this.openSnackBar(res.message, "");
        this.dialogRef.close(true);
      } else {
        this.openSnackBar(res.message, "");
        this.dialogRef.close(false);
      }
    }, (err) => {
      console.log("error", err)
    })
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
  onSelectFile(event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      
      if(file.type.indexOf('image')> -1){
        this.format = 'image';
      } else if(file.type.indexOf('video')> -1){
        this.format = 'video';
      }
      reader.onload = (event) => {
        this.url = (<FileReader>event.target).result;
        console.log(this.url);
        let imgFile = new File([file], this.url);
        console.log(imgFile)
        this.productImg = file;
      }
    }
  }

  closeTab() {
    this.dialogRef.close(false);
  }

}
